import React, { useEffect, useState } from 'react';
import './UpdateBanner.css';

const UpdateBanner = () => {
  const [show, setShow] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    // Listen for SW update events from index.html's registration
    const handleMessage = (e) => {
      if (e.data && e.data.type === 'SW_UPDATED') {
        showBanner();
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);
    window.addEventListener('message', handleMessage);

    // Check existing registration for updates
    navigator.serviceWorker.getRegistration().then(reg => {
      if (!reg) return;
      setRegistration(reg);

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            showBanner();
          }
        });
      });
    });

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const showBanner = () => {
    setShow(true);
    // Auto-dismiss after 3 seconds to be less intrusive
    setTimeout(() => setShow(false), 3000);
  };

  const refresh = () => {
    if ('caches' in window) {
      caches.keys().then(keys => {
        Promise.all(keys.map(k => caches.delete(k))).then(() => {
          window.location.reload();
        });
      });
    } else {
      window.location.reload();
    }
  };

  if (!show) return null;

  return (
    <div className="vtd-update-banner" onClick={refresh} role="alert">
      <span className="vtd-update-banner__icon">✨</span>
      <span className="vtd-update-banner__text">
        New update ready! <strong>Tap to refresh</strong>
      </span>
      <button
        className="vtd-update-banner__close"
        onClick={(e) => { e.stopPropagation(); setShow(false); }}
        aria-label="Dismiss"
      >×</button>
    </div>
  );
};

export default UpdateBanner;